import React from "react";
import { Helmet } from "react-helmet-async";
import { commonPageTitle } from "../../utils/constants";

const PageTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{`${commonPageTitle} | ${title}`}</title>
    </Helmet>
  );
};

export default PageTitle;
